import React from "react";

const LogoutContext = React.createContext();

export default LogoutContext;
